const cleanPath = (path?: string) =>
  path
    ?.replace(/\?.*/gi, '')
    .replace(/\/\d+$/, '')
    .replace(/\/$/, '');

export default cleanPath;
